import { Modal } from 'bootstrap';

const modalElement = document.getElementById('educationCenterVideoModal');
const cardVideos = document.querySelectorAll('[data-education-center-video]');
const videoTriggers = document.querySelectorAll('[data-education-center-video-trigger]');

if (modalElement && cardVideos.length > 0 && videoTriggers.length > 0) {
  const modalVideo = modalElement.querySelector('[data-education-center-lightbox-video]');
  const modalSource = modalElement.querySelector('[data-education-center-lightbox-source]');
  const modal = Modal.getOrCreateInstance(modalElement);

  const resetModalVideo = () => {
    modalVideo.pause();
    modalVideo.currentTime = 0;
    modalVideo.removeAttribute('poster');
    modalSource.removeAttribute('src');
    modalSource.removeAttribute('type');
    modalVideo.load();
  };

  cardVideos.forEach((video) => {
    video.controls = false;
    video.pause();
    video.currentTime = 0;
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
  });

  videoTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      resetModalVideo();
      modalSource.setAttribute('src', trigger.dataset.videoUrl);
      modalSource.setAttribute('type', trigger.dataset.videoMime || 'video/mp4');

      if (trigger.dataset.videoPoster) {
        modalVideo.setAttribute('poster', trigger.dataset.videoPoster);
      }

      modalVideo.load();
      modal.show(trigger);
    });
  });

  modalElement.addEventListener('hide.bs.modal', () => {
    modalVideo.pause();
    modalVideo.currentTime = 0;
  });

  modalElement.addEventListener('shown.bs.modal', () => {
    modalVideo.play().catch(() => {
      // The visible native controls remain available if autoplay is blocked.
    });
  });

  modalElement.addEventListener('hidden.bs.modal', resetModalVideo);
}
